import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  providers: [
    AuthenticationService
  ],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)'}),
          animate('250ms', style({transform: 'translateX(0)'}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)'}),
          animate('250ms', style({transform: 'translateX(100%)'}))
        ])
      ]
    )
  ]
})

export class NavigationComponent implements OnInit {
  
  constructor(private AuthenticationService: AuthenticationService) {
    
  }
  
  ngOnInit() {

  }

  logout(): void {
    this.AuthenticationService.logout();
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/navigation/navigation.component.ts